import {
  Badge,
  Card,
  DataList,
  HStack,
  Skeleton,
  Stack,
} from "@chakra-ui/react";
import React from "react";

export const TransactionInfoSkeleton = () => {
  return (
    <DataList.Root orientation="horizontal" divideY="1px" maxW="md">
      {Array.from({ length: 9 }).map((_, index) => (
        <DataList.Item key={index} pt="4">
          <DataList.ItemLabel width="40%" fontSize="xs">
            <Skeleton asChild loading={true} width="100%" variant="shine">
              <Badge>Select</Badge>
            </Skeleton>
          </DataList.ItemLabel>
          <DataList.ItemValue fontSize="xs">
            <Skeleton asChild loading={true} width="100%" variant="shine">
              <Badge>Select</Badge>
            </Skeleton>
          </DataList.ItemValue>
        </DataList.Item>
      ))}
    </DataList.Root>
  );
};
